import React, { useEffect } from 'react';
import './styles/DraftLeague.css';
import { Link } from 'react-router-dom';
import basketballImg from './assets/basketball.png';

const Schedule = () => {
  useEffect(() => {
    document.documentElement.style.setProperty(
      '--basketball-image',
      `url(${basketballImg})`
    );
  }, []);

  return (
    <div className="hero">
      {/* Background */}
      <div className="hero-background" />
      <div className="hero-overlay" />

      {/* Floating elements */}
      <div className="floating-element-1" />
      <div className="floating-element-2" />
      <div className="floating-element-3" />

      {/* Main Content */}
      <div className="hero-content">
        <Link to="/" className="hero-link">
          <h1 className="hero-title">
            Grass Valley
            <br />
            <span className="hero-title-bold">Draft League</span>
          </h1>
        </Link>
        {/* Schedule Container - properly contained */}
        <div className="schedule-container-hero">
          <h2 className="schedule-title">Season 7 Schedule</h2>

          <div className="schedule-table">
            <div className="schedule-row">
              <div className="game-date">SUN, AUG 9</div>
              <div className="game-details">
                <div className="game-teams">Draft Night</div>
                <div className="game-time">6:00 PM</div>
                <div className="game-location">Silver Springs HS</div>
              </div>
            </div>

            <div className="schedule-row">
              <div className="game-date">SUN, AUG 23</div>
              <div className="game-details">
                <div className="game-teams">Week 1 Games</div>
                <div className="game-time">5PM, 6PM, 7PM, 8PM</div>
                <div className="game-location">Silver Springs HS</div>
              </div>
            </div>

            <div className="schedule-row">
              <div className="game-date">SUN, AUG 30</div>
              <div className="game-details">
                <div className="game-teams">Week 2 Games</div>
                <div className="game-time">5PM, 6PM, 7PM, 8PM</div>
                <div className="game-location">Silver Springs HS</div>
              </div>
            </div>

            <div className="schedule-row">
              <div className="game-date"></div>
              <div className="game-details">
                <div className="game-teams">Labor Day (No Games)</div>
                <div className="game-time"></div>
                <div className="game-location"></div>
              </div>
            </div>

            <div className="schedule-row">
              <div className="game-date">SUN, SEP 13</div>
              <div className="game-details">
                <div className="game-teams">Week 3 Games</div>
                <div className="game-time">5PM, 6PM, 7PM, 8PM</div>
                <div className="game-location">Silver Springs HS</div>
              </div>
            </div>

            <div className="schedule-row">
              <div className="game-date">SUN, SEP 20</div>
              <div className="game-details">
                <div className="game-teams">Week 4 Games</div>
                <div className="game-time">5PM, 6PM, 7PM, 8PM</div>
                <div className="game-location">Silver Springs HS</div>
              </div>
            </div>

            <div className="schedule-row">
              <div className="game-date">SUN, SEP 27</div>
              <div className="game-details">
                <div className="game-teams">Week 5 Games</div>
                <div className="game-time">5PM, 6PM, 7PM, 8PM</div>
                <div className="game-location">Silver Springs HS</div>
              </div>
            </div>

            <div className="schedule-row">
              <div className="game-date">SUN, OCT 4</div>
              <div className="game-details">
                <div className="game-teams">Week 6 Games</div>
                <div className="game-time">5PM, 6PM, 7PM, 8PM</div>
                <div className="game-location">Silver Springs HS</div>
              </div>
            </div>

            <div className="schedule-row">
              <div className="game-date">SUN, OCT 11</div>
              <div className="game-details">
                <div className="game-teams">Week 7 Games</div>
                <div className="game-time">5PM, 6PM, 7PM, 8PM</div>
                <div className="game-location">Silver Springs HS</div>
              </div>
            </div>

            <div className="schedule-row">
              <div className="game-date">SUN, OCT 18</div>
              <div className="game-details">
                <div className="game-teams">Week 8 Games</div>
                <div className="game-time">5PM, 6PM, 7PM, 8PM</div>
                <div className="game-location">Silver Springs HS</div>
              </div>
            </div>

            <div className="schedule-row">
              <div className="game-date">SUN, OCT 25</div>
              <div className="game-details">
                <div className="game-teams">Week 9 Games</div>
                <div className="game-time">5PM, 6PM, 7PM, 8PM</div>
                <div className="game-location">Silver Springs HS</div>
              </div>
            </div>

            <div className="schedule-row">
              <div className="game-date">SUN, NOV 1</div>
              <div className="game-details">
                <div className="game-teams">Playoff Games</div>
                <div className="game-time">5PM, 6PM, 7PM, 8PM</div>
                <div className="game-location">Silver Springs HS</div>
              </div>
            </div>

            <div className="schedule-row">
              <div className="game-date">SUN, NOV 8</div>
              <div className="game-details">
                <div className="game-teams">Playoff Games</div>
                <div className="game-time">6PM, 7PM</div>
                <div className="game-location">Silver Springs HS</div>
              </div>
            </div>

            <div className="schedule-row">
              <div className="game-date">SUN, NOV 15</div>
              <div className="game-details">
                <div className="game-teams">Championships</div>
                <div className="game-time">6PM</div>
                <div className="game-location">Silver Springs HS</div>
              </div>
            </div>
          </div>
        </div>
        <div className="cards-container">
          <Link
            to="/"
            className="card-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="card">
              <h3 className="card-title">Home</h3>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Schedule;
